import { useEffect, useState } from "react";

// Breakpoints mirror the responsive design in styles.css.
//   mobile  : < 768px
//   tablet  : 768px - 1023px
//   desktop : >= 1024px

export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() =>
    typeof window !== "undefined" ? window.matchMedia(query).matches : false,
  );
  useEffect(() => {
    const mql = window.matchMedia(query);
    const onChange = (e: MediaQueryListEvent) => setMatches(e.matches);
    setMatches(mql.matches);
    mql.addEventListener("change", onChange);
    return () => mql.removeEventListener("change", onChange);
  }, [query]);
  return matches;
}

export function useIsMobile(): boolean {
  return useMediaQuery("(max-width: 767px)");
}

export function useIsTabletOrBelow(): boolean {
  return useMediaQuery("(max-width: 1023px)");
}
